// extracted by mini-css-extract-plugin
export default {"title":"FasilitasPelatihan_title__xojxV","fasilitasItems":"FasilitasPelatihan_fasilitasItems__GTx4v","fasilitasItem":"FasilitasPelatihan_fasilitasItem__eNHeC"};